import { render, staticRenderFns } from "./OrmMessageView.vue?vue&type=template&id=55c4287c"
import script from "./OrmMessageView.vue?vue&type=script&lang=js"
export * from "./OrmMessageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports